let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("120fV")).then(() => parcelRequire('5CGAS'));